export const MONTH_IN_MILLIS = 2629746000;
export const TICK_INTERVAL = 4;
